(function ($) {
  'use strict';

  var block = 'commerce-product-default-full';

  Drupal.behaviors.frontendCommerceProductDefaultFull = {
    attach: function (context) {


      $('.' + block, context).each(function () {
        var slickPreview = $('.' + block + '__image-preview .' + block + '__images', this);
        var slickTrack = $('.' + block + '__image-track .' + block + '__images', this);

        slickPreview.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: slickTrack
        });

        var slides = 4;

        slickTrack.slick({
          slidesToShow: slides,
          slidesToScroll: 1,
          asNavFor: slickPreview,
          dots: false,
          draggable: false,
          arrows: false,
          focusOnSelect: true
        });
      });
    }
  };

})(jQuery);
